import { InstalledSoftware } from "./InstalledSoftware";
import { Stock } from "./Stock";
import { Tag } from "./Tag";
import { MachineEcrCode } from "./ecr/MachineEcrCode";
import { CashTypeEnum } from "./enums/CashTypeEnum";
import { RecognitionSensorLicense } from "./recognitionSensor/RecognitionSensorLicense";

export class Machine {
    /**InstallationName */
    installationName: string = null;

    /**Machine id in this installation */
    machineId: number = -1;

    /**Machine Serial Number */
    serialNumber: string = null;

    /**Machine model */
    model: string = null;

    /**Machine installed software */
    installedSoftwares: InstalledSoftware[] = [];

    /** Supported cash type */
    supportedCashType: CashTypeEnum = CashTypeEnum.Unknown;

    /** Machine workmode (useful for older machine models) */
    workmode: string = null;

    /**Recognition sensor model */
    recognitionSensorModel: string = null;

    /**Recognition sensor license */
    recognitionSensorLicense: RecognitionSensorLicense = null;

    /**User defined tag list */
    tags: Tag[] = [];

    /**Ecr code informations */
    ecrCode: MachineEcrCode = null;

    stocksConfig: Stock[] = null;

    public parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.MachineId) this.machineId = obj.MachineId;
        if (obj.SerialNumber) this.serialNumber = obj.SerialNumber;
        if (obj.Model) this.model = obj.Model;
        if (obj.InstalledSoftwares && obj.InstalledSoftwares.length > 0) {
            obj.InstalledSoftwares.forEach((e) => {
                var m: InstalledSoftware = new InstalledSoftware();
                m.parse(e);
                this.installedSoftwares.push(m);
            });
        }
        if (obj.SupportedCashType != null && Object.values(CashTypeEnum).includes(obj.SupportedCashType)) this.supportedCashType = obj.SupportedCashType;
        if (obj.Workmode) this.workmode = obj.Workmode;
        if (obj.RecognitionSensorModel) {
            this.recognitionSensorModel = obj.RecognitionSensorModel;
        }
        if (obj.RecognitionSensorLicense) {
            this.recognitionSensorLicense = new RecognitionSensorLicense();
            this.recognitionSensorLicense.parse(obj.RecognitionSensorLicense);
        }
        if (obj.EcrCode) {
            this.ecrCode = new MachineEcrCode();
            this.ecrCode.parse(obj.EcrCode);
        }
        if (obj.StocksConfig && obj.StocksConfig.length > 0) {
            this.stocksConfig = [];
            obj.StocksConfig.forEach((e) => {
                var s: Stock = new Stock();
                s.parse(e);
                this.stocksConfig.push(s);
            });
        }
    }
}
